import Vue from "vue";
import Router from "vue-router";
import Index from "@/components/Formula";
// import Register from "@/components/Register"; // 选手信息
// import TrackType from "@/components/TrackType"; // 选择赛道
// import TrackComplete from "@/components/TrackComplete"; // 全栈赛道
// import TrackCreative from "@/components/TrackCreative"; // 创意赛道
// import Success from "@/components/Success"; // 创意赛道
import Home from "@/components/MFormula";
// import MRegister from "@/components/MRegister"; // 选手信息
// import MTrackType from "@/components/MTrackType"; // 选择赛道
// import MTrackComplete from "@/components/MTrackComplete"; // 全栈赛道
// import MTrackCreative from "@/components/MTrackCreative"; // 创意赛道
// import MSuccess from "@/components/MSuccess"; // 创意赛道
// import Expect from "@/components/Expect"; // 敬请期待-过度页面
// import MVote from "@/components/MVote"; // 二阶段-手机
// import Vote from "@/components/Vote"; // 二阶段-PC
import MFormula from "@/components/MFormula"; // 三阶段-公式750
import Formula from "@/components/Formula"; // 三阶段-公式1920

Vue.use(Router);

export default new Router({
    mode: "history",
    base: "/72Hours/",
    routes: [
        { path: "/", name: "Index", component: Index },
        // { path: "/Register", name: "Register", component: Register },
        // { path: "/TrackType", name: "TrackType", component: TrackType },
        // {
        //     path: "/TrackComplete",
        //     name: "TrackComplete",
        //     component: TrackComplete
        // },
        // {
        //     path: "/TrackCreative",
        //     name: "TrackCreative",
        //     component: TrackCreative
        // },
        // { path: "/Success", name: "Success", component: Success },
        // { path: "/Vote", name: "Vote", component: Vote },
        { path: "/Formula", name: "Formula", component: Formula },
        { path: "/Home", name: "Home", component: Home },
        // { path: "/MRegister", name: "MRegister", component: MRegister },
        // { path: "/MTrackType", name: "MTrackType", component: MTrackType },
        // {
        //     path: "/MTrackComplete",
        //     name: "MTrackComplete",
        //     component: MTrackComplete
        // },
        // {
        //     path: "/MTrackCreative",
        //     name: "MTrackCreative",
        //     component: MTrackCreative
        // },
        // { path: "/MSuccess", name: "MSuccess", component: MSuccess },
        // { path: "/Expect", name: "Expect", component: Expect },
        // { path: "/MVote", name: "MVote", component: MVote },
        { path: "/MFormula", name: "MFormula", component: MFormula }
    ]
});



// WEBPACK FOOTER //
// ./src/router/index.js